<template>
  <v-main>
    <v-container fill-height>
      <v-row justify="center" align="center">
        <v-col cols="11" sm="5">
          <v-card elevation="5">
            <v-card-title class="justify-center card-title pb-0">Customer Portal</v-card-title>
            <v-img class="my-14" contain src="../assets/Full-colour.png" alt="logo" height="50"></v-img>
            <v-checkbox class="ml-6" v-model="isCheck" hide-details>
              <template v-slot:label>
                <div>I accept the
                  <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                      <a href="https://www.sic.co.th/privacy-policy-of-nfc-business-name-card/" target="_blank"
                        v-bind="props">Privacy Policy</a>
                    </template>
                  </v-tooltip>
                </div>

              </template>
            </v-checkbox>
            <div class="mt-0 ml-8">
              <a href="https://documents.sic.co.th/pdf/usermanual/Customer%20Portal%20User%20Manual.pdf" target="_blank"
                rel="noopener noreferrer">User Manual</a>
            </div>
            <v-card-text class="text-red">
              <p>*Please ensure that your browser's pop-up blocker is disabled</p>
              <p>**Your <strong>online store account is not valid</strong> for use here. Please register a separate
                account</p>
            </v-card-text>
            <v-btn class="btn" block elevation="2" color="info" @click="toLogin">Log in</v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="isDialog" max-width="500">
      <v-card>
        <v-card-title>Privacy Policy is Required</v-card-title>
        <v-card-text>Please accept the Privacy Policy before proceed further</v-card-text>
        <v-card-actions>
          <v-btn color="info" @click="isDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
export default {
  props: {
    login: Function,
  },
  data: () => ({
    isCheck: true,
    isDialog: false,
  }),
  methods: {
    toLogin() {
      if (this.isCheck) {
        this.login();
      } else {
        this.isDialog = true;
      }
    }
  }
};
</script>